import { render, staticRenderFns } from "./TreatmentSetItemListTable.vue?vue&type=template&id=47836355&scoped=true&"
import script from "./TreatmentSetItemListTable.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetItemListTable.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetItemListTable.vue?vue&type=style&index=0&id=47836355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47836355",
  null
  
)

export default component.exports